/**
 * * @module pages/memberships.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";

const TicketDiscounts = Backbone.View.extend({
  el: $(document),
  events: {
    "click .show-more.button": "showMoreItems",
  },

  initialize: function () {
    this.render();
  },

  showMoreItems: function (e) {
    const $button = $(e.target);
    const $itemsContainer = $button.parent().prev(".ticket-discounts-block");
    $(".event-block", $itemsContainer).removeClass("hidden");

    $(e.target).parent().remove();
  },

  addShowMoreBtn: function ($this_container) {
    var $showMoreBtnWrapper = $this_container.next(".show-more-container");
    $showMoreBtnWrapper.append(
      '<button class="show-more button">See more</button>'
    );
  },

  showMore: function (container) {
    const _this = this;
    const $container = $(container);
    const $blocks = $(".event-block", $container);

    $container.each(function () {
      let $this_container = $(this);
      let $items = $(".event-block", $this_container);
      const length = $items.length;

      if (length > 4) {
        const $items = $(
          ".event-block:not(.item-1):not(.item-2):not(.item-3):not(.item-4)",
          $this_container
        );
        $items.addClass("hidden");

        _this.addShowMoreBtn($this_container);
      }
    });
  },

  render: function () {
    this.showMore(".ticket-discounts-block");
    // this.showMore();
  },
});

export default TicketDiscounts;
